// extracted by mini-css-extract-plugin
module.exports = {"wrap":"game-item_wrap_RCh7r","desc":"game-item_desc_3-q9N","btn":"game-item_btn_1lCri"};